import { render } from "./uploadFabricExcelModal.vue?vue&type=template&id=31e68e34&ts=true"
import script from "./uploadFabricExcelModal.vue?vue&type=script&lang=ts"
export * from "./uploadFabricExcelModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__